module.exports = __webpack_public_path__ + "static/img/8.6119fed.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/1/sp/8.png
// module id = YlTi
// module chunks = 0